var exports = {
  "kL": "x31de4314--d1429c--container",
  "nf": "x31de4314--d1429c--link",
  "Kk": "x31de4314--d1429c--icon",
  "y_": "x31de4314--d1429c--remoteness",
};

module.exports = exports;
